import React, { useState } from 'react';
import Icon from './Icon';
import { money } from '../hooks';

const CATEGORIES = ['Popular', 'Biryani', 'Curries', 'Breads', 'Drinks'];
const ITEMS = [
  { name: 'Chicken Biryani', price: 16.99, hue: 28 },
  { name: 'Paneer Tikka', price: 14.49, hue: 12 },
  { name: 'Butter Chicken', price: 16.99, hue: 20 },
  { name: 'Garlic Naan', price: 3.99, hue: 40 },
];
const SPICE = ['Mild', 'Medium', 'Hot', 'Extra hot'];

const FEATURES = [
  ['kiosk', 'Pickup or dine-in', 'Guests choose how they eat, and dine-in orders carry the table number to the kitchen.'],
  ['list', 'Customize everything', 'Sizes, spice levels and special requests, using the same options your phone AI offers.'],
  ['heart', 'Built-in tipping', '10%, 15%, 20% or a custom amount, chosen at checkout.'],
  ['lock', 'Locked down and self-updating', 'Runs in kiosk mode on an Android tablet and installs new features automatically.'],
];

// Interactive mini-kiosk: tap dishes to add them, pick a spice level.
export default function Kiosk() {
  const [cat, setCat] = useState(0);
  const [cart, setCart] = useState([ITEMS[0], ITEMS[3]]);
  const [spice, setSpice] = useState(1);
  const total = cart.reduce((s, i) => s + i.price, 0);

  return (
    <section className="section light" id="kiosk">
      <div className="wrap split split--reverse">
        <div className="split__copy" data-reveal>
          <p className="eyebrow">Self-order kiosk</p>
          <h2 className="h2">
            The line moves itself. <em>Your staff get to cook.</em>
          </h2>
          <p className="lead lead--dark">
            Put a kiosk on the counter. Guests browse photos, customize their dish and order in
            under a minute. The order lands in the same kitchen queue as phone orders.
          </p>
          <div className="mini-features">
            {FEATURES.map(([icon, title, body]) => (
              <div key={title} className="mini-feature">
                <Icon name={icon} />
                <h3>{title}</h3>
                <p>{body}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="kiosk-wrap" data-reveal>
          <div className="kiosk" aria-label="Interactive kiosk preview">
            <div className="kiosk__top">
              <span className="kiosk__logo">Your Restaurant</span>
              <span className="pill pill--soft">Pickup</span>
            </div>
            <div className="kiosk__cats">
              {CATEGORIES.map((c, i) => (
                <button key={c} className={i === cat ? 'is-active' : ''} onClick={() => setCat(i)}>
                  {c}
                </button>
              ))}
            </div>
            <div className="kiosk__grid">
              {ITEMS.map((item) => (
                <button key={item.name} className="kiosk__item" onClick={() => setCart((c) => [...c, item])}>
                  <span className="kiosk__img" style={{ '--h': item.hue }} />
                  <span className="kiosk__name">{item.name}</span>
                  <span className="kiosk__price">
                    {money(item.price)}
                    <span className="kiosk__add" aria-label={`Add ${item.name}`}>
                      <Icon name="plus" size={14} />
                    </span>
                  </span>
                </button>
              ))}
            </div>
            <div className="kiosk__custom">
              <span>Spice level</span>
              <div className="kiosk__spice">
                {SPICE.map((s, i) => (
                  <button key={s} className={i === spice ? 'is-active' : ''} onClick={() => setSpice(i)}>
                    {s}
                  </button>
                ))}
              </div>
            </div>
            <div className="kiosk__cart">
              <span>
                <b>{cart.length}</b> items · {money(total)}
              </span>
              <button className="kiosk__checkout" onClick={() => setCart([])}>
                {cart.length ? 'Checkout' : 'Cart empty'}
              </button>
            </div>
          </div>
          <p className="kiosk-wrap__hint">Try it: tap a dish to add it to the cart.</p>
        </div>
      </div>
    </section>
  );
}
